import { takeLatest, put, call } from 'redux-saga/effects'
// FIXS

import Axios from 'axios'
import { IBlockInstanceTypeModel } from 'models/block.model'
import { getRichTextBlock } from 'api/lessons/block-instances/GetRichTextBlock'
import getSurveyBlock from 'api/lessons/block-instances/GetSurveyBlock'
import { getTaskBlock } from 'api/lessons/block-instances/GetTaskBlock'
import { getMultimediaBlock } from 'api/lessons/block-instances/GetMultimediaBlock'
import { getEvaluationBlock } from 'api/lessons/block-instances/GetEvaluationBlock'
import { getScormBlock } from 'api/lessons/block-instances/GetScormBlock'
import { getMeetingBlock } from 'api/lessons/block-instances/GetMeetingBlock'
import { BlockTypes } from 'enum/block-type.enum'
import * as fromActions from '../../../actions/lessons.action'

async function getLessonContentList(data: IBlockInstanceTypeModel[]) {
  const content = [] as any
  const promises: Promise<any>[] = data.map(async ({ id, type }) => {
    switch (type) {
      case BlockTypes.BlockSurvey:
        return getSurveyBlock(id)
      case BlockTypes.BlockRichText:
        return getRichTextBlock(id)
      case BlockTypes.BlockTask:
        return getTaskBlock(id)
      case BlockTypes.BlockMultimedia:
        return getMultimediaBlock(id)
      case BlockTypes.BlockEvaluation:
        return getEvaluationBlock(id)
      case BlockTypes.BlockScorm:
        return getScormBlock(id)
      case BlockTypes.BlockMeeting:
        return getMeetingBlock(id)
      default:
        return null
    }
  })
  const result = await Axios.all(promises)

  result.map((instance: any) => content.push(instance))
  return content
}

function* blockListEffectSaga(action: any) {
  try {
    const instancesIds: any = []
    const { blockInstances, lessonId } = action.payload
    blockInstances.map(async (instance: any) => {
      instance.lessonId === lessonId &&
        instancesIds.push({
          id: instance.blockInstanceableId,
          type: instance.blockInstanceableType,
        })
    })
    const data = yield call(getLessonContentList, instancesIds)
    yield put(fromActions.Actions.lessonsGetLessonContentSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* getLessonBlocksContentWatcherSaga() {
  yield takeLatest(fromActions.LESSONS_GET_LESSON_CONTENT, blockListEffectSaga)
}
